import "./css/appear.css";
import "./css/base.css";
import "./css/bounce.css";
import "./css/disappear.css";
import "./css/flicker.css";
import "./css/flip-bottom-up.css";
import "./css/fly-bottom.css";
import "./css/fly-left.css";
import "./css/fly-right.css";
import "./css/fly-top.css";
import "./css/jello.css";
import "./css/pulse.css";
import "./css/roll.css";
import "./css/scale.css";
import "./css/shake.css";
import "./css/spin.css";
import "./css/wobble.css";

import "./onClickCss/bounce.css";

interface Timeouts {
  [name: string]: { enter: number; exit: number };
}

export const animationTimeouts: Timeouts = {
  "fly-left": {
    enter: 500,
    exit: 500,
  },
  "fly-top": {
    enter: 500,
    exit: 500,
  },
  "fly-bottom": {
    enter: 500,
    exit: 500,
  },
  "fly-right": {
    enter: 500,
    exit: 500,
  },
  appear: {
    enter: 1000,
    exit: 1000,
  },
  disappear: {
    enter: 1000,
    exit: 1000,
  },
  flicker: {
    enter: 4000,
    exit: 4000,
  },
  "flip-bottom-up": {
    enter: 1000,
    exit: 1000,
  },
  jello: {
    enter: 900,
    exit: 900,
  },
  roll: {
    enter: 600,
    exit: 600,
  },
  shake: {
    enter: 800,
    exit: 800,
  },
  spin: {
    enter: 500,
    exit: 500,
  },
  scale: {
    enter: 300,
    exit: 300,
  },
  bounce: {
    enter: 1100,
    exit: 1500,
  },
  pulse: {
    enter: 400,
    exit: 400,
  },
  wobble: {
    enter: 1500,
    exit: 1500,
  },
};
